// Generated by ReScript, PLEASE EDIT WITH CARE

import * as EventsTrackerHelper$PorterinFeature from "./EventsTrackerHelper.mjs";
import * as PublishEventsHelper$PorterinFeature from "./PublishEventsHelper.mjs";

function publishPageLandEvent(category, event_name) {
  PublishEventsHelper$PorterinFeature.publishEvents(category, event_name, undefined);
}

function publishPageLandEventWithParameter(category, event_name, parameter_event_name, parameter) {
  PublishEventsHelper$PorterinFeature.publishEvents(category, event_name, undefined);
  EventsTrackerHelper$PorterinFeature.publishEventParameter(parameter_event_name, parameter);
}

export {
  publishPageLandEvent ,
  publishPageLandEventWithParameter ,
}
/* EventsTrackerHelper-PorterinFeature Not a pure module */
